import React, { useEffect, useState } from 'react';
// @ts-ignore
import DHTypography from "@digital-hig/mui/Typography";
// @ts-ignore
import DHBox from "@digital-hig/mui/Box";
import { cacheManager } from '../../utils/cacheManager';

interface HeaderSectionProps {
  welcomeMessage?: string;
  pageTitle?: string;
}

export const HeaderSection: React.FC<HeaderSectionProps> = ({ 
  welcomeMessage, 
  pageTitle = "Home" 
}) => {
  const [displayMessage, setDisplayMessage] = useState<string>('Good afternoon, User');

  useEffect(() => {
    // Try to get cached user info directly from CacheManager
    const cachedUserInfo = cacheManager.getCachedUserInfo();
    if (cachedUserInfo) {
      setDisplayMessage(`Good afternoon, ${cachedUserInfo.userName}`);
      
    } else {
      // Fallback to default message
      setDisplayMessage(welcomeMessage || 'Good afternoon, User');
    }
  }, [welcomeMessage]);

  const finalWelcomeMessage = welcomeMessage || displayMessage;
  return (
    <DHBox 
      sx={{ 
        display: 'flex', 
        flexDirection: 'column', 
        gap: 3, 
        alignItems: 'flex-start', 
        mb: 3,
        // Digital HIG responsive width
        width: { xs: '100%', sm: '100%', md: '100%', lg: '1296px', xl: '1296px' },
        // Digital HIG breakpoint for 1320px
        '@media (min-width: 1320px)': {
          width: '1296px'
        },
        '@media (max-width: 1319px)': {
          width: '100%'
        }
      }}
    >
      {/* Welcome Message */}
      <DHBox sx={{ 
        textAlign: 'left', 
        display: 'flex', 
        alignItems: 'center',
        // Digital HIG responsive height
        height: { xs: 'auto', sm: 'auto', md: 'auto', lg: '77px', xl: '77px' },
        // Digital HIG breakpoint for 1320px
        '@media (min-width: 1320px)': {
          height: '77px'
        },
        '@media (max-width: 1319px)': {
          height: 'auto',
          minHeight: { xs: '50px', sm: '60px', md: '60px' }
        }
      }}>
        <DHTypography 
          variant="headline-large" 
          component="h1" 
          sx={{ 
            marginBottom: 0, 
            paddingBottom: 0,
            fontFamily: 'Artifakt Legend',
            fontWeight: 800,
            // Digital HIG responsive font size
            fontSize: { xs: '24px', sm: '28px', md: '32px', lg: '34px', xl: '34px' },
            lineHeight: '120%',
            letterSpacing: '0%',
            // Digital HIG breakpoint for 1320px
            '@media (min-width: 1320px)': {
              fontSize: '34px',
              lineHeight: '120%'
            },
            '@media (max-width: 1319px)': {
              fontSize: { xs: '24px', sm: '28px', md: '32px' },
              lineHeight: '120%'
            }
          }}
        >
          {finalWelcomeMessage}
        </DHTypography>
      </DHBox>

      {/* Page Title */}
      <DHBox sx={{ 
        textAlign: 'left', 
        display: 'flex', 
        alignItems: 'center',
        // Digital HIG responsive height
        height: { xs: 'auto', sm: 'auto', md: 'auto', lg: '26px', xl: '26px' },
        // Digital HIG breakpoint for 1320px
        '@media (min-width: 1320px)': {
          height: '26px'
        },
        '@media (max-width: 1319px)': {
          height: 'auto',
          minHeight: { xs: '20px', sm: '24px', md: '24px' }
        }
      }}>
        <DHTypography 
          variant="headline-small" 
          component="h2" 
          sx={{ 
            margin: 0, 
            padding: 0,
            fontFamily: 'Artifakt Element',
            fontWeight: 700,
            // Digital HIG responsive font size
            fontSize: { xs: '18px', sm: '20px', md: '21px', lg: '21px', xl: '21px' },
            lineHeight: '125%',
            letterSpacing: '0%',
            // Digital HIG breakpoint for 1320px
            '@media (min-width: 1320px)': {
              fontSize: '21px',
              lineHeight: '125%'
            },
            '@media (max-width: 1319px)': {
              fontSize: { xs: '18px', sm: '20px', md: '21px' },
              lineHeight: '125%'
            }
          }}
        >
          {pageTitle}
        </DHTypography>
      </DHBox>
    </DHBox>
  );
};

